import { notNull } from '@gap/utils/utils'
import { useRegionRouterStore } from 'features/main/RegionRouterStore'
import { observer } from 'mobx-react-lite'
import useInitialMount from 'reusable/hooks/useInitialMount'
import useQuery from 'reusable/hooks/useQuery'

export default observer(function XeroCallback() {
   const queryString = useQuery()
   const regionRouterStore = useRegionRouterStore()

   useInitialMount(async () => {
      const callbackParams = {
         ...(queryString.get('code') ? { xeroCode: queryString.get('code') || undefined } : {}),
         ...(queryString.get('state') ? { xeroState: queryString.get('state') || undefined } : {}),
         ...(queryString.get('error') ? { xeroError: queryString.get('error') || undefined } : {}),
      }

      // There are no expected queryString params, so we shouldn't be here
      if (!Object.values(callbackParams).some((value) => !!value)) {
         regionRouterStore.navigate('/')
      }

      const newQueryString = new URLSearchParams(callbackParams).toString()

      switch (regionRouterStore.pathWithoutRegion) {
         case '/xero-callback/trial':
            regionRouterStore.navigate(`/trial?${newQueryString}`)
            return
         case '/xero-callback/quickstart':
            regionRouterStore.navigate(`/org/${notNull(queryString.get('state'))}/work-items?${newQueryString}&quickstart=true&xpm=true`)
            return
         case '/xero-callback/app':
         default: {
            // Return the user to the page they left; XpmConnectionStore redeems the code there.
            const storedPath = sessionStorage.getItem('xpm-return-path')
            if (storedPath) {
               sessionStorage.removeItem('xpm-return-path')
               const regionPrefix = `/${regionRouterStore.region}`
               const regionlessStored = storedPath.startsWith(regionPrefix) ? storedPath.slice(regionPrefix.length) : storedPath
               const separator = regionlessStored.includes('?') ? '&' : '?'
               regionRouterStore.navigate(`${regionlessStored}${separator}${newQueryString}`)
               return
            }
            regionRouterStore.navigate(`/org/${notNull(queryString.get('state'))}/my-organisation/integrations?${newQueryString}`)
         }
      }
   })

   return null
})
